if (!customElements.get('nox-product')) {
  customElements.define(
    'nox-product',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const galleryControls = this.querySelector('.nox-product__gallery-controls');
        if (galleryControls) galleryControls.hidden = false;
        this.addEventListener('click', (event) => {
          const galleryButton = event.target.closest('[data-gallery-button]');
          if (galleryButton) {
            this.selectGalleryImage(galleryButton);
          }
          const variantButton = event.target.closest('[data-variant-button]');
          if (variantButton) {
            const select = this.querySelector('[data-variant-select]');
            select.value = variantButton.dataset.variantButton;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const galleryDirection = event.target.closest('[data-gallery-direction]');
          if (galleryDirection) {
            const buttons = Array.from(this.querySelectorAll('[data-gallery-button]'));
            const currentIndex = buttons.findIndex((button) => button.getAttribute('aria-pressed') === 'true');
            const nextButton = buttons[currentIndex + Number(galleryDirection.dataset.galleryDirection)];
            if (nextButton) this.selectGalleryImage(nextButton);
          }
          const quantityButton = event.target.closest('[data-quantity-change]');
          if (quantityButton) {
            const quantity = this.querySelector('[name="quantity"]');
            if (quantityButton.dataset.quantityChange === '1') quantity.stepUp();
            else quantity.stepDown();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
        this.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
          const option = event.target.selectedOptions[0];
          this.querySelectorAll('[data-variant-button]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.variantButton === option.value));
          });
          this.querySelector('[data-variant-price]').textContent = option.dataset.price;
          const compare = this.querySelector('[data-variant-compare]');
          compare.textContent = option.dataset.compare;
          compare.hidden = option.dataset.onSale !== 'true';
          this.querySelector('[data-variant-saving]').hidden = option.dataset.onSale !== 'true';
          this.querySelector('[data-saving-amount]').textContent = option.dataset.saving;
          this.querySelector('[data-add-button]').disabled = option.dataset.available !== 'true';
          this.querySelector('[data-add-label]').textContent =
            option.dataset.available === 'true'
              ? this.querySelector('[data-add-button]').dataset.buyLabel
              : window.variantStrings.soldOut;
          const quantity = this.querySelector('[name="quantity"]');
          quantity.min = option.dataset.min;
          quantity.step = option.dataset.step;
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.value = option.dataset.min;
        });
      }

      selectGalleryImage(galleryButton) {
        this.querySelectorAll('[data-gallery-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.galleryPanel !== galleryButton.dataset.galleryButton;
        });
        const buttons = Array.from(this.querySelectorAll('[data-gallery-button]'));
        buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button === galleryButton));
        });
        const index = buttons.indexOf(galleryButton);
        const previous = this.querySelector('[data-gallery-direction="-1"]');
        const next = this.querySelector('[data-gallery-direction="1"]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = index === buttons.length - 1;
        const thumbnails = galleryButton.closest('.nox-product__thumbnails');
        if (thumbnails.scrollWidth > thumbnails.clientWidth) {
          thumbnails.scrollTo({
            left: thumbnails.scrollLeft + galleryButton.getBoundingClientRect().left -
              thumbnails.getBoundingClientRect().left - (thumbnails.clientWidth - galleryButton.offsetWidth) / 2,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        }
      }
    }
  );
}

if (!customElements.get('nox-video-slider')) {
  customElements.define(
    'nox-video-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-video-track]');
        this.previous = this.querySelector('[data-video-direction="-1"]');
        this.next = this.querySelector('[data-video-direction="1"]');
        this.updateControls = () => {
          this.previous.disabled = this.track.scrollLeft <= 1;
          this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
        };
        this.onClick = (event) => {
          const button = event.target.closest('[data-video-direction]');
          if (!button) return;
          const cards = this.track.children;
          if (cards.length < 2) return;
          this.track.scrollBy({
            left: (cards[1].offsetLeft - cards[0].offsetLeft) * Number(button.dataset.videoDirection),
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          });
        };
        this.querySelector('[data-video-controls]').hidden = false;
        this.track.addEventListener('scroll', this.updateControls, { passive: true });
        this.addEventListener('click', this.onClick);
        this.resizeObserver = new ResizeObserver(this.updateControls);
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }

      disconnectedCallback() {
        this.track.removeEventListener('scroll', this.updateControls);
        this.removeEventListener('click', this.onClick);
        this.resizeObserver.disconnect();
      }
    }
  );
}

document.addEventListener('click', (event) => {
  const link = event.target.closest('.nox-mobile-menu a');
  if (link) link.closest('details').open = false;
});
